const ContextTypes = {
    ALL_SHOTS: 'allShots',
    SESSION: 'session'
};

export default ContextTypes